
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/[caseid]",
      function () {
        return require("private-next-pages/case-studies/[caseid]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/[caseid]"])
      });
    }
  